var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper p-0"},[_c('div',{staticClass:"content"},[_vm._m(0),_c('ApiKeyManager',{key:_vm.clinicUrl,attrs:{"level":"clinic","clinic-url":_vm.clinicUrl},on:{"revealed-change":v => (_vm.revealed = v)}}),_c('Dialog',{ref:"Dialog"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"mb-3"},[_c('i',{staticClass:"fas fa-key mr-2"}),_vm._v("API Keys")])
}]

export { render, staticRenderFns }